import { FormFieldType, TFormField } from '@models/forms';
import { SubjectivityItem } from '@pages/QuoteDetails/sidebarItems/subjectivities/SubjectivitiesItem';
import { Box, Icon, Typography } from '@mui/material';
import { Tooltip } from '@components/tooltip/Tooltip';
import { InfoCircle } from '@assets/svgs';

type AvailableLOI = {
  label: string;
  id: string;
};

export const getSubjectivitiesFormFields = (
  isBroker: boolean | undefined,
  isInternalUser: boolean | undefined,
  selectedItem: SubjectivityItem | undefined,
  availableLOIS: AvailableLOI[] | undefined,
  isLoadedFromLibrary: boolean | undefined,
): { [fieldName: string]: TFormField } => {
  return {
    insuranceLineId: {
      name: 'insuranceLineId',
      label: 'Line Of Insurance',
      fieldType: FormFieldType.SelectField,
      required: false,
      disabled: selectedItem?.offeringSubjectivityId ? true : false,
      gridWidth: { xs: 12, sm: 12, md: 12 },
      fieldConfig: {
        selectField: {
          options: [
            { label: 'Common', value: 'Common' },
            ...(availableLOIS?.map((item) => ({
              label: item.label,
              value: item.id,
            })) || []),
          ],
        },
      },
    },
    dueDaysAfterPolicyEffective: {
      name: 'dueDaysAfterPolicyEffective',
      label: 'Due Days after Policy Effective Date',
      fieldType: FormFieldType.TextField,
      required: !isBroker,
      gridWidth: { xs: 12, sm: 12, md: 12 },
      fieldConfig: {
        textField: {
          inputType: 'number',
        },
      },
    },
    description: {
      name: 'description',
      label: 'Description',
      fieldType: FormFieldType.TextField,
      required: false,
      gridWidth: { xs: 12, sm: 12, md: 12 },
      disabled: isInternalUser ? false : Boolean(selectedItem?.offeringSubjectivityId),
      fieldConfig: {
        textField: {
          multiline: true,
          rows: 5,
        },
      },
    },
    saveToLibrary: {
      name: 'saveToLibrary',
      label: 'Save to Library?',
      fieldType: FormFieldType.CheckboxField,
      required: false,
      gridWidth: { xs: 12, sm: 12, md: 12 },
      isVisible: !isLoadedFromLibrary && !selectedItem,
      fieldConfig: {
        checkboxField: {
          CustomLabelComponent: (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <Typography variant='bodySmall'>Save to Library?</Typography>
              <Tooltip
                title={
                  isInternalUser
                    ? 'Save a manual subjectivity to your library if you would like yourself and other Underwriters to be able to re-use this subjectivity in the future.'
                    : 'Save a manual subjectivity to your library if you would like to be able to re-use this subjectivity in the future.'
                }
                placement='bottom'
                arrow
              >
                <Icon sx={{ color: 'text.subdued' }}>
                  <InfoCircle />
                </Icon>
              </Tooltip>
            </Box>
          ),
        },
      },
    },
  };
};
